// @flow
import { noop } from '@boi/core/lib/utils';
import { format } from 'date-fns';
import React from 'react';

import type { LatestUserQuoteSearchResponseModel } from '../../types/Home';
import AgGridTable from '../AgGridTable/AgGridTable';

type Props = {
  results: LatestUserQuoteSearchResponseModel[],
  onSelectQuote: (string, string) => noop
};

const parsePremium = ({ params }: { params: null }) => {
  if (
    params?.value === undefined ||
    params?.value === null ||
    params?.value === 0
  ) {
    return `-`;
  } else {
    return `€${parseFloat(params?.value).toFixed(2)}`;
  }
};

export const SearchResults = ({ results, onSelectQuote }: Props) => {
  const columnDefs = [
    { headerName: 'First Name', field: 'first_name', floatingFilter: true },
    { headerName: 'Last Name', field: 'last_name', floatingFilter: true },
    {
      headerName: 'Date of Birth',
      field: 'date_of_birth',
      floatingFilter: true
    },
    {
      headerName: 'Registered Customer',
      field: 'fully_registered',
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      valueGetter: (params: any) => {
        return params.data.fully_registered ? 'Yes' : 'No';
      }
    },
    {
      headerName: 'Bind Status',
      field: 'payment_channel',
      floatingFilter: true,
      cellStyle: {
        color: 'green',
        fontWeight: 'bold'
      }
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 400,
      cellRenderer: (params: any) => {
        const tooltipText = `Email: ${params.value}`;
        return `<span title='${tooltipText}'>
                <p id='emailLink${params.value}'>${params.value}</p>
              </span>`;
      },
      onCellClicked: function(params: any) {
        if (params.column.colId === 'email') {
          const email = params.data.email;
          const policyCode = params.data.policy_code;
          onSelectQuote(email, policyCode);
        }
      },
      floatingFilter: true
    },
    {
      headerName: 'Policy Code',
      field: 'policy_code',
      floatingFilter: true
    },
    {
      headerName: 'InsurSmart Quote',
      field: 'itb',
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      valueGetter: (params: any) => {
        return params.data.itb ? 'Yes' : 'No';
      }
    },
    {
      headerName: 'Policy Start Date',
      field: 'policy_start_date',
      floatingFilter: true,
      valueGetter: (params: any) => {
        const dateTime = new Date(params.data.policy_start_date);
        return format(dateTime, 'DD-MM-YYYY');
      }
    },
    {
      headerName: 'Policy Number',
      field: 'policy_number',
      floatingFilter: true
    },
    {
      headerName: 'Mortgage Application Number',
      field: 'mortgage_reference',
      floatingFilter: true
    },
    {
      headerName: 'Intact',
      field: 'rsa_quote_amount',
      floatingFilter: true,
      valueFormatter: (params: any) => {
        return parsePremium({ params: params });
      }
    },
    {
      headerName: 'FBD',
      field: 'fbd_quote_amount',
      floatingFilter: true,
      valueFormatter: (params: any) => {
        return parsePremium({ params: params });
      }
    },
    {
      headerName: 'Promocode',
      field: 'promo_code_alias',
      floatingFilter: true
    },
    {
      headerName: 'Timestamp',
      field: 'quote_timestamp',
      floatingFilter: true
    },
    {
      headerName: 'Dwelling type',
      field: 'dwelling_type',
      floatingFilter: true
    },
    {
      headerName: 'Branch',
      field: 'branch',
      floatingFilter: true
    }
  ];

  return <AgGridTable rowData={results} columnDefs={columnDefs} />;
};
